import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import HowItWorks from '../components/HowItWorks';
import Independence from '../components/Independence';
import Navigation from '../components/Navigation';
// import SuccessStories from '../components/SuccessStories';
// import Blog from '../components/Blog';
// import JoinCommunity from '../components/JoinCommunity';
import Footer from '../components/Footer';

const Home: React.FC = () => {
    return (
        <>
            <Navigation logoSrc="/logo512.png" />
            <Hero />
            <About />
            <HowItWorks />
            <Independence />
            {/* <SuccessStories /> */}
            {/* <Blog /> */}
            {/* <JoinCommunity /> */}
            <Footer />
        </>
    );
};

export default Home;
